  <ul class="list-inline list-color">
    <li class="list-inline-item cursor-pointer secondary-paragraph tag-user"
      *ngFor="let user of taggedUsers | slice:0:limit; let last = last"
      (click)="userProfile(user)">
      {{specialCharacter.AT}}{{user.full_name}}<span *ngIf="!last">{{specialCharacter.COMMA}}</span>
    </li>
    <li class="list-inline-item cursor-pointer secondary-paragraph font-italic"
      (click)="openPostDetail()"
      *ngIf="taggedUsers.length > limit">
      <span class="color-grey-500">{{specialCharacter.AND}} {{mls.languageText.tagged_users.key1}}</span>
    </li>
  </ul>